import { useState } from "react";

import { Input } from "@/components/ui/Input";
import {
  formatDraftUnitPriceDisplay,
  sanitizeDraftUnitPriceInput,
} from "@/lib/purchaseOrderDraftForm";
import { cn } from "@/lib/utils";

export function PurchaseOrderDraftUnitPriceInput({
  value,
  disabled,
  onChange,
  onBlur,
  className,
}: {
  value: string;
  disabled: boolean;
  onChange: (next: string) => void;
  onBlur?: () => void;
  className?: string;
}): JSX.Element {
  const [focused, setFocused] = useState(false);
  const displayValue = focused ? value : formatDraftUnitPriceDisplay(value);

  return (
    <Input
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={displayValue}
      disabled={disabled}
      onFocus={() => setFocused(true)}
      onChange={(event) => onChange(sanitizeDraftUnitPriceInput(event.target.value))}
      onBlur={() => {
        setFocused(false);
        onChange(formatDraftUnitPriceDisplay(value));
        onBlur?.();
      }}
      className={cn(className)}
    />
  );
}
